import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { Block } from 'emotion-jsxstyle';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';

interface NavigatorProps {
  appState: AppState;
}

interface NavigatorState {
  isOpen: boolean;
}

export class Navigator extends React.Component<NavigatorProps, NavigatorState> {
  state: NavigatorState = {
    isOpen: false,
  };

  componentDidMount() {
    // We need to handle the case when user opens Sidebar on mobile (ie. this.state.isOpen: true)
    // and then resizes the window before closing the sidebar. In this situation, we need to force
    // the Sidebar closed. This is not possible without JS. Luckily, `react-media` puts `matchMedia`
    // on the window.
    // As for #perf, matchMedia is more performant than listening to the resize event.
    // @see https://stackoverflow.com/questions/37086372/how-does-addlistener-work-with-matchmedia-api
    (window as any)
      .matchMedia('(min-width: 768px)')
      .addListener(this.forceCloseSidebar, this.setState({ isOpen: true }));
  }

  componentWillUnmount() {
    // Clean up our listener. Reaslistically this never gets called because Navigator
    // never unmounts. However, its good practice to clean things up anyways
    (window as any).matchMedia('(min-width: 768px)').removeListener(this.forceCloseSidebar);
  }

  toggleNav = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  forceCloseSidebar = () => {
    this.setState({ isOpen: false });
  };

  public render() {
    return (
      <Block height="100%" width="100%" margin="0" padding="0">
        <Navbar currentUser={this.props.appState.user!} toggleNav={this.toggleNav} isOpen={this.state.isOpen} />
        <Sidebar
          currentUser={this.props.appState.user!}
          onClose={this.forceCloseSidebar}
          isOpen={this.state.isOpen}
          appState={this.props.appState}
        />
        <Block
          height="100%"
          width="100%"
          background="#f1f5f9"
          paddingTop={56}
          paddingLeft={this.state.isOpen ? 240 : 0}
        >
          {this.props.children}
        </Block>
      </Block>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/layout/Navigator/Navigator.tsx